import { FontSizeHTML } from "configs";

/**
 * Convert from "pixel" to "rem"
 */
export const rem = (fs: number) => `${fs / FontSizeHTML}rem`;
